if($('.sticky-under-navbar')) {
    $('.sticky-under-navbar').css("top", $('.navbar-main').outerHeight(true));
}

if($('.block-list_images').hasClass("sidebar-width-translate")) {
    var sidebarWidth = $(".sidebar-collapsible").width();
    var contentOffest = sidebarWidth + 24;
    $(".slider-content__text__item").css("padding-left", contentOffest);
    $(".slider-content__text__item").css("padding-right", contentOffest);
}

/**
 * Generate a secure password with at least one uppercase, one lowercase, one digit, and one special character.
 * @param {number} length
 * @returns {string}
 */
window.generateSecurePassword = function(length = 16) {
    const upper = 'A';
    const lower = 'a';
    const numbers = '0';
    const specials = '!';
    const all = upper + lower + numbers + specials;
    const randomize = window.randomize;

    let password = '';
    // Ensure at least one of each required character
    password += randomize(upper, 1);
    password += randomize(lower, 1);
    password += randomize(numbers, 1);
    password += randomize(specials, 1);
    // Fill the rest
    password += randomize(all, length - 4);
    // Shuffle the result
    password = password.split('').sort(() => 0.5 - Math.random()).join('');
    return password;
};
